
import React from 'react'
import { Card } from '../../_metronic/_partials/controls'
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

export default function Help() {

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const Accordion = styled((props) => (
        <MuiAccordion disableGutters elevation={0} square {...props} />
    ))(({ theme }) => ({
        border: `1px solid ${theme.palette.divider}`,
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    }));

    const AccordionSummary = styled((props) => (
        <MuiAccordionSummary
            expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
            {...props}
        />
    ))(({ theme }) => ({
        backgroundColor:
            theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, .05)'
                : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    }));

    const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)',
    }));
    function According({ title, mapKey, children }) {
        return (

            <Accordion expanded={expanded === mapKey} onChange={handleChange(mapKey)}>
                <AccordionSummary
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography sx={{ width: '100%', flexShrink: 0 }}>
                        {title}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        {children}
                    </Typography>
                </AccordionDetails>
            </Accordion>

        );
    };

    const marketingData = [
        {
            about: "The Banner Listing Module of the custom Dashboard is developed to help the module to analyze all the banners that are created including the various platforms such as BigCommerce, Shopify, etc.",
            key: "marketingListing"
        },
        {
            about: "The admin will be able to see the existing banners that have been assigned to the website.",
            key: "marketingListing"
        },
        {
            about: "In addition to that, the admin will be able to search any banner by using the parameter as a Banner name.Below the banner listing section, the pagination section is available, which will allow the admin to list various banners and also allow the admin to switch to another page to view more banners.",
            key: "marketingListing"
        },
        {
            about: "The banner listing page section will contain the details related to the banner.",
            key: "marketingListing"
        },
        {
            about: "The “Add Banner” button, available at the top of the Banner Listing Module, will help the admin to add a new banner for the website.",
            key: "marketingAdd"
        },
        {
            about: "By clicking on the “Add Banner” the admin will be redirected to the Add banner page.",
            key: "marketingAdd"
        },
        {
            about: "The add banner page will allow the admin to create a new banner and provide the banner information.",
            key: "marketingAdd"
        },
        {
            about: "If the admin will save the details of the new banner then, the same will reflect in the database and the relevant pages.",
            key: "marketingAdd"
        },
        {
            about: "The admin will be able to edit or delete the listed banners from the listing table itself.",
            key: "marketingEdit"
        },
        {
            about: "By clicking on the “edit icon” the admin will be redirected to the edit page of the relevant banner.",
            key: "marketingEdit"
        },
        {
            about: "The edit banner page will have all the fields available related to the banner details such as Banner name, Banner ordering, Banner file, Banner status, etc.",
            key: "marketingEdit"
        },
        {
            about: "If the admin will change any details from the Edit banner page and save them, then the same will reflect in the database and the relevant pages.",
            key: "marketingEdit"
        },
        {
            about: "The admin will be able to delete the listed banners from the listing table itself.",
            key: "marketingDelete"
        },
        {
            about: "By clicking on the delete icon” the admin will be redirected to the listing page after deleting the banner.",
            key: "marketingDelete"
        },
        {
            about: "The Platform Categories Module is to allow the admin to manage the categories ordering for the Shopify, Wix, and WooCommerce platforms.",
            key: "categoryList"
        },
        {
            about: "The admin will be able to see the listing of the categories of the relevant platforms, with the category order information.",
            key: "categoryList"
        },
        {
            about: "From the Category listing section, if the admin will click on the “action icon”, then the admin will be redirected to the Edit Category Order Page.",
            key: "categoryEdit"
        },
        {
            about: "The “Edit Category Order Page” will allow the admin to change the order of the relevant category.",
            key: "categoryEdit"
        },
        {
            about: "The Platform pricing module will allow the admin to view, manage and add the pricing plan for the various platforms.",
            key: "platformPricing"
        },
        {
            about: "On the Platform pricing listing section, we will display the existing available plans, which are relevant to the platforms.",
            key: "platformPricing"
        },
        {
            about: "The “Add New Price” button, available at the top of the Plan Listing Module, will help the admin to add a new Pricing Plan for the website. By clicking on the “Add New Price” button the admin will be redirected to the Add Plan page.",
            key: "addPricing"
        },
        {
            about: "The add plan page will allow the admin to create a new pricing plan and provide the pricing information.",
            key: "addPricing"
        },
        {
            about: "If the admin will save the details of the new plan then, the same will reflect in the database and the relevant pages.",
            key: "addPricing"
        },
        {
            about: "Also, the admin will be able to edit or delete the listed plan from the listing table itself. By clicking on the “edit icon” the admin will be redirected to the edit page of the relevant plan.",
            key: "editPricing"
        },
        {
            about: "The edit plan page will have all the fields available related to the plan details such as Plan name, Plan type, etc.",
            key: "editPricing"
        },
        {
            about: "If the admin will change any details from the Edit plan page and save them, then the same will reflect in the database and the relevant pages",
            key: "editPricing"
        },
        {
            about: "In order to sync the product data, the admin will just need to click on the product sync button to the relevant platform, and the product synchronization process will start itself.",
            key: "productSync"
        },
        {
            about: "The Setting Module will contain two different tabs for Maintenance Mode and SMTP Details, Where the Maintenance Mode will contain the platform listings.",
            key: "settings"
        },
        {
            about: "The Maintenance Mode page will allow the admin to switch any platform to the “Maintenance Mode” action.",
            key: "settings"
        },
        {
            about: "By switching any platform to the “Maintenance Mode”, the relevant platform will stop functioning at the front-end the relevant message to the Maintenance Mode will be displayed.",
            key: "settings"
        },
        {
            about: "In other words, the “Maintenance Mode” section will allow the admin to simply switch any platform to Maintenance Mode while performing any customizations or modifications.",
            key: "settings"
        },




    ];


    const marketingListing = marketingData && marketingData.filter((info) => {

        return info.key === "marketingListing"
    })

    const marketingAdd = marketingData && marketingData.filter((info) => {

        return info.key === "marketingAdd"
    })
    const marketingEdit = marketingData && marketingData.filter((info) => {

        return info.key === "marketingEdit"
    })
    const marketingDelete = marketingData && marketingData.filter((info) => {

        return info.key === "marketingDelete"
    })
    const categoryEdit = marketingData && marketingData.filter((info) => {

        return info.key === "categoryEdit"
    })
    const productSync = marketingData && marketingData.filter((info) => {

        return info.key === "productSync"
    })
    const categoryList = marketingData && marketingData.filter((info) => {
        return info.key === "categoryList"
    })
    const platformPricing = marketingData && marketingData.filter((info) => {
        return info.key === "platformPricing"
    })
    const addPricing = marketingData && marketingData.filter((info) => {
        return info.key === "addPricing"
    })
    const editPricing = marketingData && marketingData.filter((info) => {
        return info.key === "editPricing"
    })
    const settings = marketingData && marketingData.filter((info) => {
        return info.key === "settings"
    })


    // console.log(editInfo)

    // console.log(marketingData, "marketingData")
    return (
        <Card>
            <div className="wrapper-menu ">
                <According title="About Marketing Banners?" mapKey="marketingListing">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                marketingListing && marketingListing.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/banner.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="How to Add Marketing Banners?" mapKey="marketingAdd">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                marketingAdd && marketingAdd.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/add_banner.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>

                </According>
                <According title="How to Edit Marketing Banners?" mapKey="marketingEdit">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                marketingEdit && marketingEdit.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/edit_banner.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>

                    </div>
                </According>
                <According title="How to Delete Marketing Banner?" mapKey="marketingDelete">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                marketingDelete && marketingDelete.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/delete_banner.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>

                    </div>
                </According>
                <According title="About Merchants Module?" mapKey="merchantListing">
                    <div className='wrapper-text'>
                        <ul>
                            <li>
                                In the Merchant Module, the listing of the merchants of the Wix and WordPress platform will be available.
                            </li>
                            <li>
                                By switching the tab from the tab section, the admin will be able to see the merchant detail of the different platforms.
                            </li>
                            <li>
                                Wix Platform:
                                <ul>
                                    <li>On the Wix platform listing, the listing of all the merchants will be available. The listing will contain Store URL, Store ID, Email Id, and second Email Id.</li>
                                    <li>All the details available in the listing section are for display purposes only.</li>
                                </ul>
                            </li>
                            <li>
                                WordPress Platform:
                                <ul>
                                    <li>On the WordPress platform listing, the listing of all the merchants will be available. The listing will contain the User Id, Store URL, Email Id, and second Email Id.</li>
                                    <li>All the details available in the listing section are for display purposes only.</li>
                                </ul>
                            </li>
                            <div className=''>
                                <img src="/media/settingsImages/merchants.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>

                    </div>
                </According>
                <According title="About Categories?" mapKey="categoryListing">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                categoryList && categoryList.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/categories.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="How To Edit Categories?" mapKey="categoryEdit">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                categoryEdit && categoryEdit.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/edit_categories.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="About Product Sync Module?" mapKey="productSync">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                productSync && productSync.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/product_sync.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="About Platform Pricing Module?" mapKey="pricingListing">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                platformPricing && platformPricing.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/platform_pricing.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="How To Add Pricing Module?" mapKey="pricingAdd">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                addPricing && addPricing.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/add_pricing.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="How To Edit Pricing Module?" mapKey="pricingEdit">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                editPricing && editPricing.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/edit_pricing.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="About Setting Module?" mapKey="settingLisiting">
                    <div className='wrapper-text'>
                        <ul>
                            {
                                settings && settings.map((e) =>

                                    (<><li>{e.about}</li></>)
                                )
                            }
                            <div className=''>
                                <img src="/media/settingsImages/settings.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
                <According title="About Activity Module?" mapKey="activityLisiting">
                    <div className='wrapper-text'>
                        <ul>
                            <><li>The activity module displays all the activities performed by the end-user</li></>
                            <div className=''>
                                <img src="/media/settingsImages/activity.png" alt="" height="100%" width="100%"></img>
                            </div>
                        </ul>
                    </div>
                </According>
            </div>
        </Card>
    )
}


